import { createAPIService } from './api.service';

export const EMPLOYEES_ADMIM_ENDPOINT = '/employee/api/v1/admin/employees';

export const EMPLOYEES_ENDPOINT = '/employee/api/v1/employees';

const service = createAPIService(EMPLOYEES_ENDPOINT);

service.getEmployeesByReferenceId = async (referenceId, params) =>
  (await service.get(`/references/${referenceId}`, { params })).data;

service.getEmployeesByUuId = async (uuId, params) =>
  (await service.get(`/${uuId}`, { params })).data;
export default service;
